import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { CONTACT } from "../siteConfig";

// 오른쪽 아래 빠른 상담 버튼(메뉴 3개). 바깥 클릭·ESC·페이지 이동 시 닫힘.
export default function QuickContact() {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.key]);

  useEffect(() => {
    const onDocClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("click", onDocClick);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("click", onDocClick);
      document.removeEventListener("keydown", onKey);
    };
  }, []);

  return (
    <div ref={ref} className={"ib-quick" + (open ? " is-open" : "")}>
      <div className="ib-quick__menu" id="ibQuickMenu">
        <a href="/contact#inquiry">
          {"사업 문의하기 "}
          <span>FORM</span>
        </a>
        <a href={`mailto:${CONTACT.email}`}>
          {"이메일 보내기 "}
          <span>EMAIL</span>
        </a>
        <a href="/contact#channels">
          {"LINE · 카카오톡 상담 "}
          <span>CHAT</span>
        </a>
      </div>
      <button
        type="button"
        className="ib-quick__btn"
        aria-controls="ibQuickMenu"
        aria-expanded={open}
        aria-label="빠른 상담 메뉴"
        onClick={(e) => {
          e.stopPropagation();
          setOpen((v) => !v);
        }}
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M21 12a8 8 0 0 1-11.6 7.1L4 20.5l1.4-4.9A8 8 0 1 1 21 12Z" />
          <path d="M8.5 11.5h7M8.5 14.5h4" />
        </svg>
      </button>
    </div>
  );
}
